import styles from "./index.module.less";
import { useUser } from "@/utils/UserContext";
import { InputField } from "@wk/components-react16";
import { ButtonField } from "@wk/components-react16";
import { useState, useMemo, useEffect } from "react";
import logo from "@/assets/img/logo-screen.png";
import { getPlayerDetail, getCode, verifySmsCode } from "@/services/user";
import { useNavigate } from "react-router-dom";
import { Iconsvg } from "@wk/components-react16";
import ModalConfirm from "../player/modal";

const phoneRegex = /^1[3-9]\d{9}$/;
const Login = () => {
  const navigate = useNavigate();
  const { user, set } = useUser();
  const [phoneValue, setPhoneValue] = useState("");
  const [codeValue, setCodeValue] = useState("");
  const [inputStatus, setInputStatus] = useState("none");
  const [codeStatus, setCodeStatus] = useState("none");
  const [userInfo, setUserInfo] = useState(null);
  const [second, setSecond] = useState(0);

  const [isNextLoading, setIsNextLoading] = useState(false);
  const [isGetCode, setIsGetCode] = useState(false);

  const [isMessageOpen, setIsMessageOpen] = useState(false);
  const [messageText, setMessageText] = useState("");

  const errorText = useMemo(() => {
    if (inputStatus === "none") {
      return [];
    }
    if (!phoneValue) {
      return [{ label: "请输入手机号", labelId: "1" }];
    }

    const phoneRegex = /^1[3-9]\d{9}$/;
    if (!phoneRegex.test(phoneValue)) {
      return [{ label: "请输入正确的手机号", labelId: "2" }];
    }

    return [{ label: "您的账号未注册,需要注册后才能登录", labelId: "3" }];
  }, [inputStatus, phoneValue]);

  const errorCodeText = useMemo(() => {
    if (codeStatus === "none") {
      return [];
    }
    if (!codeValue) {
      return [{ label: "请输入验证码", labelId: "1" }];
    }

    return [{ label: "验证码错误", labelId: "2" }];
  }, [codeStatus, codeValue]);

  const next = async () => {
    if (!phoneValue || !phoneRegex.test(phoneValue)) {
      setInputStatus("error");
      return;
    }

    setIsNextLoading(true);

    const resUser = await getPlayerDetail(phoneValue);
    if (resUser.code === 200) {
      if (
        !resUser?.result?.current ||
        !(resUser?.result?.current?.status === "1")
      ) {
        setInputStatus("error");
      } else {
        setUserInfo(resUser?.result?.current);
        const resCode = await getCode(phoneValue);
        // 开始倒计时
        let time = 60;
        setSecond(--time);
        let clearTimer = setInterval(() => {
          setSecond(--time);
          if (time < 1) {
            clearInterval(clearTimer);
          }
        }, 1000);

        if (resCode.code === 200) {
          setIsGetCode(true);
        } else if (resCode.code === 500) {
          setMessageText("短信验证码发送失败，请稍后重试");
          setIsMessageOpen(true);
        }
      }
    }

    setIsNextLoading(false);
  };

  const delText = useMemo(() => {
    return `我们已向电话+XXXXXXXXXXX${phoneValue.slice(
      phoneValue.length - 2
    )}发送短信。请输入验证码以登录。`;
  }, [phoneValue]);

  const verify = async () => {
    if (!codeValue) {
      setCodeStatus("error");
      return;
    }

    setIsNextLoading(true);
    const res = await verifySmsCode(codeValue, phoneValue);
    if (res?.code === 200) {
      if (res?.result) {
        set(userInfo);

        navigate("/player");
      }
    }
    if (res?.code === 500) {
      setCodeStatus("error");
      // set(userInfo);
      // // 跳转到个人主页
      // navigate("/player");
    }

    setIsNextLoading(false);
  };

  useEffect(() => {
    if (user && user?.phone && user?.status !== "1") {
      navigate("/player");
    }
  }, [user]);

  return (
    <div className={styles["login-view"]}>
      <div className="login-box">
        <div className="login-box-content">
          <div className="login-box-content-title">
            <img src={logo} alt="logo" />
            <div
              className="login-box-content-title-text"
              onClick={() => navigate("/judgesLogin")}
            >
              评委登录
            </div>
          </div>
          <div className="modal-body-content">
            {isGetCode ? (
              <>
                <div
                  className="back"
                  onClick={() => {
                    setIsNextLoading(false);
                    setIsGetCode(false);
                    setCodeValue("");
                    setCodeStatus("none");
                  }}
                >
                  <Iconsvg name="arrow-left" size={14} color="#007AC3" />
                  返回
                </div>
                <div className="modal-text code">输入验证码</div>
                <div className="modal-del">
                  <Iconsvg name="chat-box" size={20} color="#353535" />
                  {delText}
                </div>

                <InputField
                  label="验证码"
                  labelFor="input-id-1-3"
                  status={codeStatus}
                  errors={errorCodeText}
                >
                  <input
                    type="text"
                    id="input-id-1-3"
                    name="input-1-3"
                    placeholder="请输入验证码"
                    value={codeValue}
                    onChange={(e) => {
                      setCodeValue(e.target.value);
                      if (!e.target.value) {
                        setCodeStatus("error");
                        return;
                      }
                      setCodeStatus("none");
                    }}
                    maxLength="6"
                  />
                </InputField>

                <div className="modal-button verify">
                  <ButtonField>
                    <button
                      type="button"
                      onClick={() => verify()}
                      disabled={isNextLoading}
                    >
                      验证
                      {isNextLoading && (
                        <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                      )}
                    </button>
                  </ButtonField>
                </div>
              </>
            ) : (
              <>
                <div className="modal-text">登录</div>
                <InputField
                  label="手机号"
                  labelFor="input-id-1-2"
                  status={inputStatus}
                  errors={errorText}
                >
                  <input
                    type="text"
                    id="input-id-1-2"
                    name="input-1-2"
                    placeholder="请输入手机号"
                    value={phoneValue}
                    onChange={(e) => {
                      setPhoneValue(e.target.value);
                      if (!e.target.value) {
                        setInputStatus("error");
                        return;
                      }

                      if (!phoneRegex.test(e.target.value)) {
                        setInputStatus("error");
                        return;
                      }

                      setInputStatus("none");
                    }}
                    maxLength="11"
                  />
                </InputField>
                <div className="modal-button continue">
                  <ButtonField>
                    <button
                      type="button"
                      onClick={() => next()}
                      disabled={isNextLoading || !(second < 1)}
                    >
                      {second < 1 ? "继续" : `继续(${second}s后重发)`}

                      {isNextLoading && (
                        <Iconsvg name="spinner-alt" isSpin></Iconsvg>
                      )}
                    </button>
                  </ButtonField>
                </div>
                <div className="or-text">
                  <div className="line"></div>
                  <div className="line-text">or</div>
                  <div className="line"></div>
                </div>
                <div className="modal-button registered">
                  <ButtonField mode={"ghost"}>
                    <button type="button" onClick={() => navigate("/register")}>
                      注册
                    </button>
                  </ButtonField>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <ModalConfirm
        isOpen={isMessageOpen}
        onClose={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        children={<div className="modal-body-text">{messageText}</div>}
        title={"操作确认"}
        onConfirm={() => {
          setIsMessageOpen(false);
          setMessageText("");
        }}
        okText="确认"
      />
    </div>
  );
};
export default Login;
